import React, { useEffect, useState } from 'react';
import { useScrollYPosition } from 'react-use-scroll-position';
import { Link, Element, Events, animateScroll as scroll, scrollSpy, scroller } from 'react-scroll';
import './Header.scss';
import '../Nav/Nav.scss';
import hamburger from '../../_assets/_img/hamburger.svg';
import close from '../../_assets/_img/close.svg';
const Header = () => {
  const scrollY = useScrollYPosition();
  const [hasScrolled, setHasScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    if (scrollY > 120) setHasScrolled(true);
    else setHasScrolled(false);
  }, [scrollY]);

  return (
    <header className="cnn-sponsorcontent-header">
      <nav className="cnn-navbar">
        <a href="https://www.cnn.com" data-analytics="header_logo" className="cnn-logo">
          <img src="https://i.cdn.turner.com/cnn/.element/img/4.0/logos/cnn_logo_badge.png" alt="CNN Logo Badge"/>
        </a>
        <a className="back-to-cnn"href="https://www.cnn.com">&lt; Back to CNN </a>
      </nav>
      <div className="header-banner"><p>Produced by American Express, VantageScore, and TransUnion</p></div>

    <div className={`nav ${hasScrolled ? 'scrolled' : ''}`}>

      <div className="menu-bar">
        <div className="ham" onClick={() => setIsMenuOpen(!isMenuOpen)}>
          {isMenuOpen ? <img src={close} /> : <img src={hamburger} />}
        </div>
        <div className="title">The Game Plan</div>
      </div>

      <div className="progress">
        <div className="inner-progress" style={{width: `${(Math.ceil(((scrollY / document.body.scrollHeight) * 10)) / 10) * 100}%`}}></div>
      </div>

      <div className={`submenu ${isMenuOpen ? 'open' : ''}`}>
        <Link activeClass="active" to="top" spy={true} smooth={true} offset={-100} duration={500}>
          <p><span>Understanding Cash Flow</span><span> How Do You Diagnose Where You Stand?</span></p>
        </Link>
        <Link activeClass="active" to="section-3" spy={true} smooth={true} offset={-100} duration={500}>
          <p><span>Understanding Cash Flow</span><span> How Do You Diagnose Where You Stand?</span></p>
        </Link>
        <Link activeClass="active" to="section-4" spy={true} smooth={true} offset={-100} duration={500}>
          <p><span>Understanding Credit</span><span> How To Navigate Life’s Shocks?</span></p>
        </Link>
        <Link activeClass="active" to="section-5" spy={true} smooth={true} offset={-100} duration={500}>
          <p><span>Understanding Financial Stress</span><span> How to Manage Your Mind?</span></p>
        </Link>
        <Link activeClass="active" to="section-6" spy={true} smooth={true} offset={-100} duration={500}>
          <p><span>Understanding Personal Debt</span><span> How Can You Pay Off The Past?</span></p>
        </Link>
        <Link activeClass="active" to="section-7" spy={true} smooth={true} offset={-100} duration={500}>
          <p><span>Understanding Investments</span><span> How Do You Invest In What’s Ahead?</span></p>
        </Link>
        <Link activeClass="active" to="section-8" spy={true} smooth={true} offset={-100} duration={500}>
          <p><span>Understanding Investing In Yourself</span><span>How to Build the Life You Want?</span></p>
        </Link>
      </div>
    </div>

    <div className={`desktop-nav`}>
        <Link activeClass="active" to="top" spy={true} smooth={true} offset={-100} duration={500}>
          <p><span>Understanding Cash Flow</span><span> How Do You Diagnose Where You Stand?</span></p>
        </Link>
        <Link activeClass="active" to="section-2" spy={true} smooth={true} offset={-100} duration={500}>
          <p><span>Understanding Cash Flow</span><span> How Do You Diagnose Where You Stand?</span></p>
        </Link>
        <Link activeClass="active" to="section-3" spy={true} smooth={true} offset={-100} duration={500}>
          <p><span>Understanding Cash Flow</span><span> How Do You Diagnose Where You Stand?</span></p>
        </Link>
        <Link activeClass="active" to="section-4" spy={true} smooth={true} offset={-100} duration={500}>
          <p><span>Understanding Credit</span><span> How To Navigate Life’s Shocks?</span></p>
        </Link>
        <Link activeClass="active" to="section-5" spy={true} smooth={true} offset={-100} duration={500}>
          <p><span>Understanding Financial Stress</span><span> How to Manage Your Mind?</span></p>
        </Link>
        <Link activeClass="active" to="section-6" spy={true} smooth={true} offset={-100} duration={500}>
          <p><span>Understanding Personal Debt</span><span> How Can You Pay Off The Past?</span></p>
        </Link>
        <Link activeClass="active" to="section-7" spy={true} smooth={true} offset={-100} duration={500}>
          <p><span>Understanding Investments</span><span> How Do You Invest In What’s Ahead?</span></p>
        </Link>
        <Link activeClass="active" to="section-8" spy={true} smooth={true} offset={-100} duration={500}>
          <p><span>Understanding Investing In Yourself</span><span>How to Build the Life You Want?</span></p>
        </Link>
      </div>


    </header>
    )
}
export default Header;